

















































// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Components
import { DataTable } from '../table'

// Models
import { Paginator } from '@/models'
import { TaskSheetModel, FilterTaskSheet } from '@/models/taskSheet'

// services
import { TaskSheetService } from '@/services/taskSheet'

// utils
import { loading, alerts } from '@/utils'

// constatnts
import { getTextWorkCategory, getTextWorkType } from '@/constants'

@Component({
    name: 'TableListTaskSheets',
    components: {
        DataTable
    }
})
export default class TableListTaskSheets extends Vue {
    @Prop({ type: Object, required: true }) filters!: FilterTaskSheet
    @Prop({ type: Boolean, default: false }) forceFirstPage!: boolean

    loading = false
    items: TaskSheetModel[] = []
    pagination: Paginator = {
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    }

    fields = [
        {
            key: 'actions',
            sortable: false,
            label: '',
            thClass: 'one-line w-30',
            thStyle: {
                width: '8%'
            }
        },
        {
            key: 'date',
            sortable: true,
            label: 'Fecha'
        },
        {
            key: 'work_type',
            sortable: true,
            label: 'Tipo de trabajo'
        },
        {
            key: 'work_category',
            sortable: true,
            label: 'Categoría Ocupacional'
        },
        {
            key: 'headquarter.name',
            sortable: true,
            label: 'Sede'
        },
        {
            key: 'area.name',
            sortable: true,
            label: 'Area'
        },
        {
            key: 'subArea.name',
            sortable: true,
            label: 'Sub-Area'
        }
    ]

    created () {
        this.getTaskSheetsWithPagination()
    }

    async deleteItem (item: TaskSheetModel) {
        const msg = `Seguro que desea eliminar el TAREO  de  la FECHA: ${item.date}`
        const confirm = await alerts.confirm(msg)
        if (confirm && item.id) {
            loading('show')
            await TaskSheetService.delete(item.id)
            alerts.success()
            this.getTaskSheetsWithPagination()
            loading('hide')
        }
    }

    changePage (page: number) {
        this.pagination.currentPage = page
        this.getTaskSheetsWithPagination()
    }

    changePerPage (perPage: number) {
        this.pagination.perPage = perPage
        this.pagination.currentPage = 1
        this.getTaskSheetsWithPagination()
    }

    getTextCategory (type: number) {
        return getTextWorkCategory(type)
    }

    getTextWorkType (type: number) {
        return getTextWorkType(type)
    }

    async getTaskSheetsWithPagination () {
        this.loading = true
        if (this.forceFirstPage) {
            this.pagination.currentPage = 1
        }
        const response = await TaskSheetService.getWithPagination(this.pagination.perPage, this.pagination.currentPage, this.filters)
        this.items = response.objects
        this.pagination = response.pagination
        this.loading = false
        this.$emit('load-finished', this.items)
    }
}
